import { render, staticRenderFns } from "./encyclopediaEdit.vue?vue&type=template&id=39caa0e4&scoped=true"
import script from "./encyclopediaEdit.vue?vue&type=script&lang=js"
export * from "./encyclopediaEdit.vue?vue&type=script&lang=js"
import style0 from "./encyclopediaEdit.vue?vue&type=style&index=0&id=39caa0e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39caa0e4",
  null
  
)

export default component.exports